import { render } from "./top-panel.vue?vue&type=template&id=31960fea"
import script from "./top-panel.vue?vue&type=script&lang=js"
export * from "./top-panel.vue?vue&type=script&lang=js"

import "./top-panel.vue?vue&type=style&index=0&id=31960fea&lang=scss"

import exportComponent from "/usr/src/app/frontend_result/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__